import React from 'react';
import ReactDOM from 'react-dom';
import App from './modules/App/App';
import '../styles/styles.scss';
import uncapitalizeKeys from './helpers/formatting';

const appRoot = document.getElementById('AppRoot');
const exemptionData = uncapitalizeKeys(JSON.parse(appRoot?.getAttribute('data-exemption-data')));

const reactRoot = document.createElement('div');
reactRoot.setAttribute('id', 'react-root');
appRoot.appendChild(reactRoot);

function init() {
  ReactDOM.render(
    <App exemptionData={exemptionData} />,
    reactRoot,
  );
}

init();
